import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

function NotFound(props) {

  const location = useLocation();

  useEffect(function onLoad() {

    window.location.href = location.pathname;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function renderMain() {

    return <div id="not-found-main">
    
    </div>;

  }

  return renderMain();

}

export default NotFound;